/* tslint:disable */
/* eslint-disable */

/**
 * To restart onboarding for DoorDash, current status needs to be in error state and aggregatorOnboarding need to be in MENU_BLOCK state
 */
export enum StoreAggregatorOnboardingStatus {
  Start = 'start',
  Pending = 'pending',
  Confirmed = 'confirmed',
  Error = 'error',
  MenuPulled = 'menu_pulled',
  RestartOnboarding = 'restart_onboarding',
  Activation = 'activation',
  ActivationPending = 'activation_pending'
}
